import { el, setChildren } from 'redom';

import application from 'application';

import SingleSelectInputBox from 'generics/components/single-select/native/input-box';
import InputRow from 'generics/components/text-input-row/row';
import TextInputBox from 'generics/components/text-input/text-area-box';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import meetingLocationTypes from 'constants/meeting-location-types';

import {
  determineLocationValueInputPlaceholder,
  determineLocationValueInputLabel
} from './utilities';

import './index.scss';

const customValueInputTypes = [
  meetingLocationTypes.OTHER,
  meetingLocationTypes.PHYSICAL
];

class LocationSection {

  constructor(configuration) {

    this.readOnly = configuration.readOnly;
    this.previousEvent = structuredClone(configuration.event);
    this.event = configuration.event;
    this.onChange = configuration.onChange || function noop() {};

    this.locationTypeInputBox = null;
    this.endLocationInputBox = null;

    this.initializeInputs();

    this.el = el('#calendar-activity-location-section-main', this.inputs);

    this.updateInputs();

  }

  initializeInputs() {

    this.locationTypeInputBox = new SingleSelectInputBox(this.buildLocationTypeInputOptions());

    this.locationTypeInputRow = new InputRow({ label: 'Location', input: this.locationTypeInputBox });

    this.initializeLocationValueInput();

  }

  initializeLocationValueInput() {

    const value = this.event.location.value;

    this.locationValueInputBox = new TextInputBox({
      disabled: this.readOnly === true,
      placeholder: 'Enter other location',
      value,
      type: 'text',
      onChange: this.handleLocationValueChange.bind(this)
    });

    this.locationValueInputRow = el('.form-input-row', [
      el('label.field-label', 'Value'),
      this.locationValueInputBox
    ]);

  }

  getLocationInputOptions() {

    const options = [{ label: 'Google', value: meetingLocationTypes.GOOGLE }, {
      label: 'Physical',
      value: meetingLocationTypes.PHYSICAL
    }, { label: 'Other', value: meetingLocationTypes.OTHER }];

    return options;

  }

  getSelectedLocationIndices() {

    const index = findIndexByPropertyValue(this.getLocationInputOptions(), 'value', this.event.location.type);

    if (index === -1) {
      return [];
    }

    return [index];

  }

  buildLocationTypeInputOptions() {

    const options = {
      disabled: this.readOnly === true,
      placeholder: 'Location',
      options: this.getLocationInputOptions(),
      selectedOptionIndices: this.getSelectedLocationIndices(),
      onChange: this.handleTypeChange.bind(this)
    };

    return options;

  }

  updateInputs() {

    this.inputs = [];

    if (this.readOnly === false) {
      this.inputs.push(this.locationTypeInputRow);
    }

    if (customValueInputTypes.includes(this.event.location.type) === true || this.readOnly === true) {

      this.inputs.push(this.locationValueInputRow);
      this.locationValueInputBox.setAttr({
        placeholder: determineLocationValueInputPlaceholder(this.event.location.type)
      });
      this.locationValueInputRow.querySelector('.field-label').textContent = determineLocationValueInputLabel(this.event.location.type);

    } else {
      this.locationValueInputBox.setValue('');
    }

    setChildren(this.el, this.inputs);

  }

  handleLocationValueChange(event, currentValue) {

    this.event.location.value = currentValue;

    const modified = this.event.location.value !== this.previousEvent.location.value;

    this.onChange({ value: { ...this.event }, modified });

  }

  async handleTypeChange({ values }) {

    const type = values[0];

    this.event.location.type = type;

    if (this.event.location.type === meetingLocationTypes.GOOGLE) {
      const connected = await application.socialNetworksManager.tryConnectGoogleCalendar();
      if (connected === false) {
        this.locationTypeInputBox.setValue(meetingLocationTypes.OTHER);
        this.event.location.type = meetingLocationTypes.OTHER;
      }
    }

    this.updateInputs();

    if (customValueInputTypes.includes(type) === true) {
      this.locationValueInputBox.focus();
    }

    const modified = this.event.location.type !== this.previousEvent.location.type;

    this.onChange({ value: { ...this.event }, modified });

  }

  setErrors(errors) {

    for (let error of errors) {

      if (error.instancePath === '/data/location/type') {
        this.locationTypeInputBox.setError('Please select location');
      }

    }

  }

  clearErrors() {

    this.locationTypeInputBox?.setError('');

  }

  getValue() {

    const type = this.locationTypeInputRow.input.getValue();
    const value = this.locationValueInputRow.input.getValue();

    const data = {
      type,
      value
    };

    return data;

  }

}

export default LocationSection;